// Closed vocabularies for analytics identifiers. Code refers to a member as
// NAME.KEY, never by its wire string, so a misspelled key is caught by the
// vocabulary scan in scripts/analytics-vocabulary.test.mjs instead of
// shipping a mislabeled value to PostHog.
const KEY = /^[A-Z][A-Z0-9_]*$/;

export function defineEnum(name, members) {
    const seen = new Set();
    for (const [key, value] of Object.entries(members)) {
        if (!KEY.test(key)) throw new Error(`${name}.${key}: enum keys are UPPER_SNAKE_CASE`);
        if (typeof value !== "string" || value === "") throw new Error(`${name}.${key}: enum values are non-empty strings`);
        if (seen.has(value)) throw new Error(`${name}: duplicate value "${value}"`);
        seen.add(value);
    }
    return Object.freeze({ ...members });
}

export function enumValues(members) {
    return Object.freeze(Object.values(members));
}

// A frozen map without a prototype, so a key read from a URL, such as
// `toString`, finds nothing instead of a built-in function.
export function defineLookup(entries) {
    return Object.freeze(Object.assign(Object.create(null), entries));
}
